/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import Paper from "@mui/material/Paper";

import { useMediaQueries } from "../../../shared";
import ErrorMessage from "../components/ErrorMessage/ErrorMessage";
import { useStyles } from "../styles";
import CardTitle from "./components/CardTitle";

interface CardWrapperProps {
  isTopSection?: boolean;
  isCreditsCard?: boolean;
  isInnerCard?: boolean;
  isDataCard?: boolean;
  children?: React.ReactNode;
  cardTitle: string;
  titleInlineAction?: React.ReactNode;
  isCompanyCards?: boolean;
  isLoading?: boolean;
  reference?: any;
  titleLoaderTestId?: string;
  titleExtention?: string | React.ReactNode;
  isError?: boolean;
  wrappedTitleInlineAction?: string | React.ReactNode;
  isNews?: boolean;
  isDashboardDownloads?: boolean;
}

const CardWrapper = ({
  isTopSection,
  isCreditsCard,
  isInnerCard,
  isDataCard,
  children,
  cardTitle,
  titleInlineAction,
  isCompanyCards,
  isLoading,
  reference,
  titleLoaderTestId,
  titleExtention,
  isError,
  wrappedTitleInlineAction,
  isNews,
  isDashboardDownloads
}: CardWrapperProps) => {
  const { toSm, to1099, from1099, fromLg } = useMediaQueries();

  const {
    dashboardPaper,
    topSection,
    creditsPaper,
    innerPaper,
    dataCard,
    cardContentBox,
    companyCardsPaper,
    newsVertical,
    dashboardDownloadsSection
  } = useStyles({
    toSm,
    to1099,
    from1099,
    fromLg,
    isCreditsCard
  });

  const topSectionStyle = isTopSection && topSection;
  const creditsCardStyle = isCreditsCard && creditsPaper;
  const innerCardStyle = isInnerCard && innerPaper;
  const dataCardStyle = isDataCard && dataCard;
  const companyCardsStyle = isCompanyCards && companyCardsPaper;
  const newsVerticalStyle = isNews && newsVertical;
  const dashboardDownloadStyle =
    isDashboardDownloads && dashboardDownloadsSection;

  return (
    <Paper
      data-testid="card-wrapper"
      elevation={0}
      sx={[
        dashboardPaper as any,
        topSectionStyle,
        creditsCardStyle,
        innerCardStyle,
        dataCardStyle,
        companyCardsStyle,
        newsVerticalStyle,
        dashboardDownloadStyle
      ]}
      ref={reference}
    >
      {/* icon should be added in front of title when needed */}
      <CardTitle
        title={cardTitle}
        titleInlineAction={!isError && titleInlineAction}
        isLoading={isLoading}
        testId={titleLoaderTestId}
        titleExtention={titleExtention}
        wrappedTitleInlineAction={wrappedTitleInlineAction}
      />
      <div css={css([cardContentBox])}>
        {isError ? <ErrorMessage /> : children}
      </div>
    </Paper>
  );
};

export default CardWrapper;
